import { gql } from "@apollo/client"

export default gql`
  type StatusType {
    id: String
    name: String
    intent: String
  }
  extend type BookingType {
    statusObj: StatusType
  }

  extend type BaseUserType {
    statusObj: StatusType
  }
  extend type TripType {
    uniqueDestinations: [AddressType]
    timeToTrip: String
    statusObj: StatusType
  }
  extend type OrderType {
    orderStatusObj: StatusType
  }
  extend type SellerType {
    categoryObj: StatusType
  }
  extend type SellableItemStockType {
    totalStockCount: Int
  }
`
